import { SwiperManager, Swiper } from '../vendor/swiper.js';

/**
 * ProductSwiperManager Class
 *
 * This class extends the SwiperManager class and provides custom features
 * for the main product swiper.
 */
class ProductSwiperManager extends SwiperManager {
    /**
     * Constructor
     */
    constructor() {
        super();
    }

    /**
     * Initializes all Swiper instances on the page
     */
    initSwipers() {
        super.initSwipers();

        // Initialize thumb Swiper
        let thumbSwiper;
        document.querySelectorAll('[data-swiper-settings]').forEach((element, index) => {
            if (element.classList.contains('thumb-swiper') || element.id === 'thumbSwiper') {
                const settings = JSON.parse(element.getAttribute('data-swiper-settings') || '{}');

                thumbSwiper = new Swiper(element, settings);

                window.swiperInstances.push({ name: element.id || `swiperInstance${index}`, instance: thumbSwiper });
            }
        });

        // Initialize main Swiper
        const mainSwiperElement = document.querySelector('.main-swiper');
        if (mainSwiperElement) {
            const settings = JSON.parse(mainSwiperElement.getAttribute('data-swiper-settings') || '{}');
            settings.thumbs = {
                swiper: thumbSwiper
            };

            const mainSwiper = new Swiper(mainSwiperElement, settings);
            window.swiperInstances.push({ name: mainSwiperElement.id || 'mainSwiper', instance: mainSwiper });
        }
    }

    /**
     * Adds a custom feature to the main product swiper.
     *
     * This feature adjusts the height of the main swiper slide and the
     * thumb swiper slide based on the window width.
     */
    addCustomFeature() {
        // Get the main swiper slide, thumb swiper slide, and thumb swiper
        const main_swiper_slide = document.querySelector('.main-swiper-slide');
        const thumb_swiper_slide = document.querySelector('.swiper-slide.thumb');
        const thumb_swiper = document.querySelector('.thumb-swiper');

        if (main_swiper_slide && thumb_swiper_slide && thumb_swiper) {
            // Get the width of the main swiper slide and thumb swiper slide
            const main_swiper_width = main_swiper_slide.offsetWidth;

            // Set the height of the main swiper slide based on the window width
            main_swiper_slide.style.height = `${main_swiper_width}px`;

            // Show the gallery container
            document.querySelector('.gallery-container').style.opacity = 1;

            // Add an event listener for window resize
            window.addEventListener('resize', () => {
                // Set the height of the main swiper slide based on the window width
                main_swiper_slide.style.height = `${main_swiper_slide.offsetWidth}px`;
            });
        }
    }
}

// Create an instance of the ProductSwiperManager class
const extendedSwiperManager = new ProductSwiperManager();

// Initialize all Swiper instances
extendedSwiperManager.initSwipers();

// Add the custom feature to the main product swiper
extendedSwiperManager.addCustomFeature();
